import { TutorialJourneyActivatorDto } from "@growth-machine-llc/stridist-api-client";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import TutorialJourneyActivatorsService from "../../../services/TutorialJourneyActivatorsService";
import { TUTORIAL_ACTIVATORS_QUERY_KEY } from "../journey/TutorialJourneysList";

export function useDeleteJourneyActivator() {
  return useOptimisticUpdateMutation({
    queryKey: [TUTORIAL_ACTIVATORS_QUERY_KEY],
    mutationFn: TutorialJourneyActivatorsService.deleteJourneyActivator,
    optimisticUpdater: {
      updateFn: (
        oldData: { activators: TutorialJourneyActivatorDto[] },
        id: number,
      ) => ({
        ...oldData,
        activators: oldData.activators.filter(
          (activator) => activator.id !== id,
        ),
      }),
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
  });
}
